import { cssVar } from '@chakra-ui/theme-tools'

const $bg = cssVar('tooltip-bg')
const $fg = cssVar('tooltip-fg')
const $arrowBg = cssVar('popper-arrow-bg')

export const Tooltip = {
  baseStyle: ({ colorScheme }: { colorScheme: string }) => {
    if (colorScheme) {
      return {
        color: 'white',
        background: `${colorScheme}.500`,
      }
    }
    return {
      bg: $bg.reference,
      color: $fg.reference,
      [$bg.variable]: 'colors.gray.900',
      [$fg.variable]: 'white',
      [$arrowBg.variable]: $bg.reference,
    }
  },
  variants: {
    dark: {
      px: 3,
      py: 2,
      color: 'white',
      backgroundColor: 'black',
      borderRadius: 'md',
      [$arrowBg.variable]: 'black',
    },
    product: {
      p: 2,
      bg: 'product.primary',
      borderRadius: 'base',
      [$arrowBg.variable]: 'colors.product.primary',
    },
  },
  defaultProps: {
    variant: 'product',
  },
}
